import { FC } from "react";
import { useNavigate } from "react-router-dom";
import {
  InformationBox,
  MuiButtonPrimary,
  MuiGrid,
} from "../../../../../components";
import {
  MODULE_PERMISSIONS,
  PAGE_IDS,
  PAGE_URLS,
} from "../../../../../helpers/constants";
import { useSiteCore } from "../../../../../hooks/useSiteCore";
import { genericAccountsSearchSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { GenericAccountsSearchHeaderWrapper } from "./GenericAccountsSearchHeader.style";
import PermissionWrapper from "../../../../../components/permissionWrapper/PermissionWrapper";

const pageId = PAGE_IDS.GENERIC_ACCOUNTS_SEARCH;

export const GenericAccountsSearchHeader: FC = () => {
  const navigate = useNavigate();
  const { fetchLabel, pageTitle } = useSiteCore();

  const handleNavigate = () => {
    navigate(PAGE_URLS.CREATE_GENERIC_ACCOUNTS);
  };
  return (
    <GenericAccountsSearchHeaderWrapper>
      <MuiGrid container>
        <MuiGrid size={{ sm: 6, xs: 12 }} className="header-left">
          <InformationBox title={pageTitle} />
        </MuiGrid>
        <MuiGrid size={{ sm: 6, xs: 12 }} className="header-right">
          <PermissionWrapper
            permission={MODULE_PERMISSIONS.GENERIC_ACCOUNT_CREATE}
          >
            <MuiButtonPrimary
              onClick={handleNavigate}
              className="header-right-button"
              id={`${pageId}-genericAccountCreate`}
              data-testid="new-generic-account"
            >
              {fetchLabel(
                genericAccountsSearchSiteCoreKeys.searchGenericAccountHeader,
                genericAccountsSearchSiteCoreKeys.createGenericAccountButton,
              )}
            </MuiButtonPrimary>
          </PermissionWrapper>
        </MuiGrid>
      </MuiGrid>
    </GenericAccountsSearchHeaderWrapper>
  );
};
